const mutations = {
  setEventContext(state, payload) {
    state.eventContext = payload;
  },
  setManualNotifications(state, payload) {
    state.manualNotifications = payload;
  },
  setAutomatedNotifications(state, payload) {
    state.automatedNotifications = payload;
  },
  setControlPointsStats(state, payload) {
    state.control_points_stats = payload;
  },
  setControlPoints(state, payload) {
    state.control_points = payload;
  },
  setProjects(state, payload) {
    state.projects = payload;
  },
};

export default mutations;
